import connectMenu from "instantsearch.js/es/connectors/menu/connectMenu.js";
import { useConnector } from "../hooks/useConnector.js";
export function useMenu(props, additionalWidgetProperties) {
  return useConnector(connectMenu, props, additionalWidgetProperties);
}